/* eslint-disable prefer-template,prefer-rest-params */
import URL_MAP from '../constants/urls';

export const buildRoute = (...args) => (
  args.reduce((prevRoute, item) => prevRoute + (typeof item === 'number'
  || item.indexOf('(') === -1 ? `/${item}` : item), '')
);

export const oneOf = (urls = [], prefix) => urls.map((url) => {
  if (prefix) {
    return buildRoute(prefix, url);
  }
  return buildRoute(url);
});

export const ROUTES = {
  TEST: {
    route: buildRoute('test'),
    breadcrumbs: [{route: '/test', description: {ru: 'TEST ONE', en: 'TEST EN'}}],
  },
  TEST_DYNAMIC: {
    route: buildRoute('test', ':id', 'info', ':data?'),
    breadcrumbs: [
      {route: 'test', description: {ru: 'Тест', en: 'Test'}},
      {
        route: ':id',
        description: ({name = '', surname = ''}) => ({
          ru: `Пользователь ${name} ${surname}`,
          en: `User ${name} ${surname}`,
        }),
        param: 'id',
      },
      {route: 'info', description: {ru: 'Инфо', en: 'Info'}},
      {
        route: ':data',
        description: ({name = '', surname = ''}) => ({
          ru: ` ${name} ${surname}`,
          en: ` ${name} ${surname}`,
        }),
        param: 'data',
      },
    ],
  },
  ROOT: {
    route: buildRoute(URL_MAP.BASE_URL),
  },
  FEED: {
    route: buildRoute(URL_MAP.FEED),
    breadcrumbs: [
      {route: URL_MAP.FEED, description: {ru: 'Общая лента', en: 'General Feed'}},
    ],
  },
  FEED_POST: {
    route: buildRoute(URL_MAP.FEED, ':id'),
    breadcrumbs: [
      {route: URL_MAP.FEED, description: {ru: 'Общая лента', en: 'General Feed'}},
      {
        route: ':id',
        description: ({ru = '', en = ''}) => ({
          ru: `${ru}`,
          en: `${en}`,
        }),
        param: 'id',
      },
    ],
  },
  LOGIN: {
    route: buildRoute(URL_MAP.LOGIN),
  },
  REGISTRATION: {
    route: buildRoute(URL_MAP.REGISTRATION),
    breadcrumbs: [
      {route: URL_MAP.REGISTRATION, description: {ru: 'Зарегистрироваться', en: 'Registration'}},
    ],
  },
  REGISTRATION_CANDIDATE: {
    route: buildRoute(URL_MAP.REGISTRATION, URL_MAP.CANDIDATE),
    breadcrumbs: [
      {route: URL_MAP.REGISTRATION, description: {ru: 'Зарегистрироваться', en: 'Registration'}},
      {route: URL_MAP.CANDIDATE, description: {ru: 'Для кандидатов', en: 'For job seekers'}},
    ],
  },
  REGISTRATION_EMPLOYERS: {
    route: buildRoute(URL_MAP.REGISTRATION, URL_MAP.EMPLOYERS),
    breadcrumbs: [
      {route: URL_MAP.REGISTRATION, description: {ru: 'Зарегистрироваться', en: 'Registration'}},
      {route: URL_MAP.EMPLOYERS, description: {ru: 'Для работодателей', en: 'For employers'}},
    ],
  },
  REGISTRATION_AGENCY: {
    route: buildRoute(URL_MAP.REGISTRATION, URL_MAP.AGENCY),
    breadcrumbs: [
      {route: URL_MAP.REGISTRATION, description: {ru: 'Зарегистрироваться', en: 'Registration'}},
      {route: URL_MAP.AGENCY, description: {ru: 'Для кадровых агентств', en: 'For recruitment agencies'}},
    ],
  },
  REGISTRATION_SERVICE: {
    route: buildRoute(URL_MAP.REGISTRATION, URL_MAP.SERVICE),
    breadcrumbs: [
      {route: URL_MAP.REGISTRATION, description: {ru: 'Зарегистрироваться', en: 'Registration'}},
      {route: URL_MAP.SERVICE, description: {ru: 'Служебная регистрация', en: 'Service registration'}},
    ],
  },
  CALL: {
    route: buildRoute(URL_MAP.CALL, ':id?'),
    breadcrumbs: [
      {route: URL_MAP.CALL, description: {ru: 'Начать видеосессию', en: 'Start video session'}},
    ],
  },
  RESTORE_PASSWORD: {
    route: buildRoute(URL_MAP.RESTORE_PASSWORD),
    breadcrumbs: [
      {route: URL_MAP.RESTORE_PASSWORD, description: {ru: 'Восстановить пароль', en: 'Restore password'}},
    ],
  },
  ABOUT_COMPANY: {
    route: buildRoute(URL_MAP.ABOUT_COMPANY),
    breadcrumbs: [{route: URL_MAP.ABOUT_COMPANY, description: {ru: 'О компании', en: 'About company'}}],
  },
  YOU_CANDIDATE: {
    route: buildRoute(URL_MAP.YOU_CANDIDATE),
    breadcrumbs: [{route: URL_MAP.YOU_CANDIDATE, description: {ru: 'Для соискателей', en: 'Для соискателей'}}],
  },
  YOU_EMPLOYER: {
    route: buildRoute(URL_MAP.YOU_EMPLOYER),
    breadcrumbs: [{route: URL_MAP.YOU_EMPLOYER, description: {ru: 'Для работодателей', en: 'Для работодателей'}}],
  },
  YOU_AGENCY: {
    route: buildRoute(URL_MAP.YOU_AGENCY),
    breadcrumbs: [{route: URL_MAP.YOU_AGENCY, description: {ru: 'Для кадровых агентств', en: 'Для кадровых агентств'}}],
  },
  CANDIDATE_SERVICE_DETAILS: {
    route: buildRoute(URL_MAP.YOU_CANDIDATE, ':service'),
    breadcrumbs: [
      {route: URL_MAP.YOU_CANDIDATE, description: {ru: 'Для соискателей', en: 'Для соискателей'}},
      {route: ':service', description: ({ru = '', en = ''}) => ({ru, en}), param: 'service'},
    ],
  },
  EMPLOYER_SERVICE_DETAILS: {
    route: buildRoute(URL_MAP.YOU_EMPLOYER, ':service'),
    breadcrumbs: [
      {route: URL_MAP.YOU_EMPLOYER, description: {ru: 'Для работодателей', en: 'Для соискателей'}},
      {route: ':service', description: ({ru = '', en = ''}) => ({ru, en}), param: 'service'},
    ],
  },
  AGENCY_SERVICE_DETAILS: {
    route: buildRoute(URL_MAP.YOU_AGENCY, ':service'),
    breadcrumbs: [
      {route: URL_MAP.YOU_AGENCY, description: {ru: 'Для кадровых агентств', en: 'Для кадровых агентств'}},
      {route: ':service', description: ({ru = '', en = ''}) => ({ru, en}), param: 'service'},
    ],
  },
  NEWS: {
    route: buildRoute(URL_MAP.NEWS),
    breadcrumbs: [{route: URL_MAP.NEWS, description: {ru: 'Новости', en: 'Новости'}}],
  },
  NEWS_PAGE: {
    route: buildRoute(URL_MAP.NEWS, ':id?'),
    breadcrumbs: [
      {route: URL_MAP.NEWS, description: {ru: 'Новости', en: 'Новости'}},
      {route: ':id', description: ({ru = '', en = ''}) => ({ru, en}), param: 'id'},
    ],
  },
  PLANS_DETAILS: {
    route: buildRoute(URL_MAP.PLANS, ':roleType?', ':period?', ':planId?'),
    breadcrumbs: [
      {route: URL_MAP.NEWS, description: {ru: 'Наши тарифы и услуги', en: 'Наши тарифы и услуги'}},
      {route: ':planId', description: ({ru = '', en = ''}) => ({ru, en}), param: 'planId'},
    ],
  },
  CONTACTS: {
    route: buildRoute(URL_MAP.CONTACTS),
    breadcrumbs: [
      {route: URL_MAP.NEWS, description: {ru: 'Контакты', en: 'Контакты'}},
    ],
  },
  REQUISITES: {
    route: buildRoute(URL_MAP.REQUISITES),
    breadcrumbs: [
      {route: URL_MAP.REQUISITES, description: {ru: 'Реквизиты', en: 'Реквизиты'}},
    ],
  },
  TECHNICAL_SUPPORT: {
    route: buildRoute(URL_MAP.TECHNICAL_SUPPORT),
    breadcrumbs: [
      {route: URL_MAP.TECHNICAL_SUPPORT, description: {ru: 'Техническая поддержка', en: 'Техническая поддержка'}},
    ],
  },
  SOFTWARE_REQUIREMENTS: {
    route: buildRoute(URL_MAP.SOFTWARE_REQUIREMENTS),
    breadcrumbs: [
      {route: URL_MAP.SOFTWARE_REQUIREMENTS, description: {ru: 'Требования к ПО', en: 'Software requirements'}},
    ],
  },
  PROCESSING_POLICY: {
    route: buildRoute(URL_MAP.PROCESSING_POLICY),
    breadcrumbs: [
      {
        route: URL_MAP.PROCESSING_POLICY,
        description: {
          ru: 'Политика обработки персональных данных',
          en: 'Политика обработки персональных данных',
        },
      },
    ],
  },
  PRIVACY_POLICY: {
    route: buildRoute(URL_MAP.DOCUMENTS, URL_MAP.PRIVACY_POLICY),
    breadcrumbs: [
      {route: URL_MAP.DOCUMENTS, description: {ru: 'Правовые документы', en: 'Правовые документы'}},
      {
        route: URL_MAP.PRIVACY_POLICY,
        description: {
          ru: 'Политика конфидециальности',
          en: 'Политика конфидециальности',
        },
      },
    ],
  },
  USER_AGREEMENT: {
    route: buildRoute(URL_MAP.DOCUMENTS, URL_MAP.USER_AGREEMENT),
    breadcrumbs: [
      {route: URL_MAP.DOCUMENTS, description: {ru: 'Правовые документы', en: 'Правовые документы'}},
      {
        route: URL_MAP.USER_AGREEMENT,
        description: {
          ru: 'Пользовательское соглашение',
          en: 'Пользовательское соглашение',
        },
      },
    ],
  },
  PERSONAL_DATA_PROCESSING: {
    route: buildRoute(URL_MAP.DOCUMENTS, URL_MAP.PERSONAL_DATA_PROCESSING),
    breadcrumbs: [
      {route: URL_MAP.DOCUMENTS, description: {ru: 'Правовые документы', en: 'Правовые документы'}},
      {
        route: URL_MAP.PERSONAL_DATA_PROCESSING,
        description: {
          ru: 'Согласие на обработку персональных данных',
          en: 'Согласие на обработку персональных данных',
        },
      },
    ],
  },
  DOCUMENTS: {
    route: buildRoute(URL_MAP.DOCUMENTS),
    breadcrumbs: [
      {route: URL_MAP.DOCUMENTS, description: {ru: 'Правовые документы', en: 'Правовые документы'}},
    ],
  },
  LEGAL_DOCUMENTS: {
    route: buildRoute(URL_MAP.LEGAL_DOCUMENTS),
    breadcrumbs: [
      {route: URL_MAP.LEGAL_DOCUMENTS, description: {ru: 'Правовые документы', en: 'Правовые документы'}},
    ],
  },
  DOCUMENTS_FILE: {
    route: buildRoute(URL_MAP.DOCUMENTS, ':category', ':id'),
    breadcrumbs: [
      {route: ':category', description: ({ru = '', en = ''}) => ({ru, en}), param: 'category'},
      {route: ':id', description: ({ru = '', en = ''}) => ({ru, en}), param: 'id'},
    ],
  },
  SERVICE_TERMS: {
    route: buildRoute(URL_MAP.SERVICE_TERMS),
    breadcrumbs: [
      {
        route: URL_MAP.SERVICE_TERMS,
        description: {
          ru: 'Условия предоставления услуг',
          en: 'Условия предоставления услуг',
        },
      },
    ],
  },
  OFERTS: {
    route: buildRoute(URL_MAP.SERVICE_TERMS, ':oferts'),
    breadcrumbs: [
      {
        route: URL_MAP.SERVICE_TERMS,
        description: {
          ru: 'Условия предоставления услуг',
          en: 'Условия предоставления услуг',
        },
      },
      {route: ':oferts', description: ({ru = '', en = ''}) => ({ru, en}), param: 'oferts'},
    ],
  },
  TERMS_OF_USE: {
    route: buildRoute(URL_MAP.TERMS_OF_USE),
    breadcrumbs: [
      {
        route: URL_MAP.TERMS_OF_USE,
        description: {
          ru: 'Условия использования сайта',
          en: 'Условия использования сайта',
        },
      },
    ],
  },
  SAFE_MNJ: {
    route: buildRoute(URL_MAP.SAFE_MNJ),
    breadcrumbs: [
      {
        route: URL_MAP.SAFE_MNJ,
        description: {
          ru: 'Безопасный My new job',
          en: 'Безопасный My new job',
        },
      },
    ],
  },
  ERROR_404: {
    route: buildRoute(URL_MAP.ERROR_404),
  },
  HELP: {
    route: buildRoute(URL_MAP.HELP),
    breadcrumbs: [
      {
        route: URL_MAP.HELP,
        description: {
          ru: 'Помощь',
          en: 'Помощь',
        },
      },
    ],
  },
  HOW_IT_WORK: {
    route: buildRoute(URL_MAP.HOW_IT_WORK),
    breadcrumbs: [
      {
        route: URL_MAP.HOW_IT_WORK,
        description: {
          ru: 'Как это работает?',
          en: 'Как это работает?',
        },
      },
    ],
  },
  VERIFY: {
    route: buildRoute(URL_MAP.VERIFY),
  },
  PROFILE_SETTINGS: {
    route: buildRoute(URL_MAP.PROFILE_SETTINGS),
    breadcrumbs: [
      {
        route: URL_MAP.PROFILE_SETTINGS,
        description: {
          ru: 'Личный кабинет',
          en: 'Личный кабинет',
        },
      },
    ],
  },
  VIDEO_POLLS: {
    route: buildRoute(URL_MAP.VIDEO_POLLS),
    breadcrumbs: [
      {
        route: URL_MAP.VIDEO_POLLS,
        description: {
          ru: 'Мои видеоопросы',
          en: 'My video surveys',
        },
      },
    ],
  },
  MY_VIDEO_POLL: {
    route: buildRoute(URL_MAP.MY_VIDEO_POLL),
    breadcrumbs: [
      {
        route: URL_MAP.MY_VIDEO_POLL,
        description: {
          ru: 'Мои видеоопросы',
          en: 'My video surveys',
        },
      },
    ],
  },
  CREATE_POLL: {
    route: buildRoute(URL_MAP.VIDEO_POLLS, URL_MAP.CREATE),
    breadcrumbs: [
      {route: URL_MAP.VIDEO_POLLS, description: {ru: 'Мои видеоопросы', en: 'My video surveys'}},
      {route: URL_MAP.CREATE, description: {ru: 'Создать видеоопрос', en: 'Create video survey'}},
    ],
  },
  SENT_POLLS: {
    route: buildRoute(URL_MAP.VIDEO_POLLS, URL_MAP.SENT_POLLS),
    breadcrumbs: [
      {route: URL_MAP.VIDEO_POLLS, description: {ru: 'Мои видеоопросы', en: 'My video surveys'}},
      {
        route: URL_MAP.SENT_POLLS,
        description: {
          ru: 'Отправленные и полученные видеоопросы',
          en: 'Sent and Received Video surveys',
        },
      },
    ],
  },
  PASSED_VIDEO_POLL: {
    route: buildRoute(URL_MAP.PASSED_VIDEO_POLL, ':id'),
  },
  VIDEO_POLL_START: {
    route: buildRoute(URL_MAP.VIDEO_POLLS, ':id', URL_MAP.START),
  },
  VIDEO_POLL_LIST: {
    route: buildRoute(URL_MAP.VIDEO_POLLS, URL_MAP.VIDEO_POLL_LIST),
    breadcrumbs: [
      {route: URL_MAP.VIDEO_POLLS, description: {ru: 'Мои видеоопросы', en: 'My video surveys'}},
      {route: URL_MAP.VIDEO_POLL_LIST, description: {ru: 'Список видеоопросов', en: 'List of video surveys'}},
    ],
  },
  VIDEO_POLL_ITEM: {
    route: buildRoute(URL_MAP.VIDEO_POLL_ITEM, ':videoPollId'),
    breadcrumbs: [
      {route: URL_MAP.VIDEO_POLLS, description: {ru: 'Мои видеоопросы', en: 'My video surveys'}},
      {route: URL_MAP.VIDEO_POLL_LIST, description: {ru: 'Мой видеоопрос', en: 'My video surveys'}},
    ],
  },
  VIDEO_POLL_FAVORITE: {
    route: buildRoute(URL_MAP.VIDEO_POLLS, URL_MAP.FAVORITE),
    breadcrumbs: [
      {route: URL_MAP.VIDEO_POLLS, description: {ru: 'Мои видеоопросы', en: 'My video surveys'}},
      {route: URL_MAP.FAVORITE, description: {ru: 'Избранные видеоопросы', en: 'Favorite video surveys'}},
    ],
  },
  VIDEO_POLL_TEMPLATES: {
    route: buildRoute(URL_MAP.VIDEO_POLLS, URL_MAP.TEMPLATES),
    breadcrumbs: [
      {route: URL_MAP.VIDEO_POLLS, description: {ru: 'Мои видеоопросы', en: 'My video surveys'}},
      {
        route: URL_MAP.TEMPLATES,
        description: {ru: 'Шаблоны вопросов и видеоопросов', en: 'Question templates and video survey templates'},
      },
    ],
  },
  ADMIN_PANEL: {
    route: buildRoute(URL_MAP.ADMIN_PANEL),
    breadcrumbs: [{
      route: URL_MAP.ADMIN_PANEL,
      description: {ru: 'Административная панель', en: 'Административная панель'},
    }],
  },
  ADMIN_PANEL_USERS_LIST: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.USERS),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.USERS,
        description: {ru: 'Список пользователей', en: 'Список пользователей'},
      },
    ],
  },
  ADMIN_PANEL_CREATE_USER: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.USERS, URL_MAP.CREATE),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.USERS,
        description: {ru: 'Список пользователей', en: 'Список пользователей'},
      },
      {
        route: URL_MAP.CREATE,
        description: {ru: 'Добавить нового пользователя', en: 'Добавить нового пользователя'},
      },
    ],
  },
  ADMIN_PANEL_EDIT_USER: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.USERS, ':_id?', URL_MAP.EDIT),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.USERS,
        description: {ru: 'Список пользователей', en: 'Список пользователей'},
      },
      {
        route: URL_MAP.CREATE,
        description: {ru: 'Редактирование пользователя', en: 'Редактирование пользователя'},
      },
    ],
  },
  ADMIN_PANEL_TARIFFS: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.TARIFFS),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.TARIFFS,
        description: {ru: 'Стандартные тарифы', en: 'Стандартные тарифы'},
      },
    ],
  },
  ADMIN_PANEL_CREATE_TARIFF: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.TARIFFS, URL_MAP.CREATE),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.TARIFFS,
        description: {ru: 'Тарифы', en: 'Тарифы'},
      },
      {
        route: URL_MAP.CREATE,
        description: {ru: 'Создание тарифа на доступ', en: 'Создание тарифа доступ'},
      },
    ],
  },
  ADMIN_PANEL_TARIFF_EDIT: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.TARIFFS, ':id', URL_MAP.EDIT),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.TARIFFS,
        description: {ru: 'Тарифы', en: 'Тарифы'},
      },
      {
        route: URL_MAP.EDIT,
        description: {ru: 'Редактировать тариф на доступ', en: 'Редактировать тариф на доступ'},
      },
    ],
  },
  ADMIN_PANEL_CREATE_TARIFF_SERVICE: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.TARIFFS, URL_MAP.TARIFF_SERVICE, URL_MAP.CREATE),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.TARIFFS,
        description: {ru: 'Тарифы', en: 'Тарифы'},
      },
      {
        route: URL_MAP.CREATE,
        description: {ru: 'Создание тарифа на услугу', en: 'Создание тарифа на услугу'},
      },
    ],
  },
  ADMIN_PANEL_TARIFF_SERVICE_EDIT: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.TARIFFS, URL_MAP.TARIFF_SERVICE, ':id', URL_MAP.EDIT),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.TARIFFS,
        description: {ru: 'Тарифы', en: 'Тарифы'},
      },
      {
        route: URL_MAP.EDIT,
        description: {ru: 'Редактировать тариф на услугу', en: 'Редактировать тариф на услугу'},
      },
    ],
  },
  ADMIN_PANEL_INSTRUCTIONS: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.INSTRUCTIONS),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.INSTRUCTIONS,
        description: {ru: 'Инструкции', en: 'Инструкции'},
      },
    ],
  },
  ADMIN_PANEL_PAYMENTS: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.PAYMENTS),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.PAYMENTS,
        description: {ru: 'Оплаты', en: 'Оплаты'},
      },
    ],
  },
  ADMIN_PANEL_LANDING_SECTION_SETTINGS: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.LANDING_SECTION_SETTINGS),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.LANDING_SECTION_SETTINGS,
        description: {ru: 'Landing Page', en: 'Landing Page'},
      },
    ],
  },
  ADMIN_PANEL_FEED: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.FEED),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.FEED,
        description: {ru: 'Общая лента', en: 'General feed'},
      },
    ],
  },
  ADMIN_PANEL_ONLINE_POLLS: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.ONLINE_POLLS),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.ONLINE_POLLS,
        description: {ru: 'Онлайн опросы', en: 'Онлайн опросы'},
      },
    ],
  },
  ADMIN_PANEL_ONLINE_POLLS_CREATE: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.ONLINE_POLLS, URL_MAP.CREATE),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.ONLINE_POLLS,
        description: {ru: 'Онлайн вопросы', en: 'Онлайн вопросы'},
      },
      {
        route: URL_MAP.CREATE,
        description: {ru: 'Создать онлайн-опрос', en: 'Создать онлайн-опрос'},
      },
    ],
  },
  ADMIN_PANEL_ONLINE_POLLS_LIST: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.ONLINE_POLLS, URL_MAP.LIST),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.ONLINE_POLLS,
        description: {ru: 'Онлайн вопросы', en: 'Онлайн вопросы'},
      },
      {
        route: URL_MAP.LIST,
        description: {ru: 'Список онлайн-опросов', en: 'Список онлайн-опросов'},
      },
    ],
  },
  ADMIN_PANEL_PASSED_ONLINE_POLLS: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.ONLINE_POLLS, URL_MAP.PASSED),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.ONLINE_POLLS,
        description: {ru: 'Онлайн вопросы', en: 'Онлайн вопросы'},
      },
      {
        route: URL_MAP.PASSED,
        description: {ru: 'Список пройденных онлайн-опросов', en: 'Список пройденных онлайн-опросов'},
      },
    ],
  },
  ADMIN_PANEL_ONLINE_POLLS_STATS: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.ONLINE_POLLS, ':id', URL_MAP.STATISTIC),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.ONLINE_POLLS,
        description: {ru: 'Онлайн вопросы', en: 'Онлайн вопросы'},
      },
      {
        route: URL_MAP.STATISTIC,
        description: {ru: 'Статистика ответов', en: 'Статистика ответов'},
      },
    ],
  },
  ADMIN_PANEL_REQUISITES: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.REQUISITES),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.REQUISITES,
        description: {ru: 'Реквизиты', en: 'Реквизиты'},
      },
    ],
  },
  ADMIN_PANEL_HOW_IT_WORK: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.HOW_IT_WORK),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.HOW_IT_WORK,
        description: {ru: 'Как это работает?', en: 'Как это работает?'},
      },
    ],
  },
  ADMIN_PANEL_VIDEO_POLL_TEMPLATES: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.VIDEO_POLL_TEMPLATES),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.VIDEO_POLL_TEMPLATES,
        description: {ru: 'Шаблоны вопросов и видеоопросов', en: 'Question templates and video survey templates'},
      },
    ],
  },
  ADMIN_PANEL_INDIVIDUAL_TARIFFS: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.INDIVIDUAL_TARIFFS),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.INDIVIDUAL_TARIFFS,
        description: {ru: 'Индивидуальные тарифы', en: 'Individual rates'},
      },
    ],
  },
  ADMIN_PANEL_INDIVIDUAL_TARIFF_CREATE: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.INDIVIDUAL_TARIFFS, URL_MAP.CREATE),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.INDIVIDUAL_TARIFFS,
        description: {ru: 'Индивидуальные тарифы', en: 'Individual rates'},
      },
      {
        route: URL_MAP.CREATE,
        description: {ru: 'Создание индивидуального тарифа', en: 'Individual rate create'},
      },
    ],
  },
  ADMIN_PANEL_INDIVIDUAL_TARIFF_EDIT: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.INDIVIDUAL_TARIFFS, ':id', URL_MAP.EDIT),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.INDIVIDUAL_TARIFFS,
        description: {ru: 'Индивидуальные тарифы', en: 'Индивидуальные тарифы'},
      },
      {
        route: URL_MAP.EDIT,
        description: {
          ru: 'Редактировать индивидуальный тариф на доступ',
          en: 'Редактировать индивидуальный тариф на доступ',
        },
      },
    ],
  },
  ADMIN_PANEL_INDIVIDUAL_TARIFF_SERVICE_CREATE: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.INDIVIDUAL_TARIFFS, URL_MAP.TARIFF_SERVICE),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.INDIVIDUAL_TARIFFS,
        description: {ru: 'Индивидуальные тарифы', en: 'Индивидуальные тарифы'},
      },
      {
        route: URL_MAP.CREATE,
        description: {
          ru: 'Создание индивидуального тарифа на услугу',
          en: 'Создание индивидуального тарифа на услугу',
        },
      },
    ],
  },
  ADMIN_PANEL_INDIVIDUAL_TARIFF_SERVICE_EDIT: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.INDIVIDUAL_TARIFFS, URL_MAP.TARIFF_SERVICE, ':id', URL_MAP.EDIT),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.INDIVIDUAL_TARIFFS,
        description: {ru: 'Индивидуальные тарифы', en: 'Индивидуальные тарифы'},
      },
      {
        route: URL_MAP.EDIT,
        description: {
          ru: 'Редактирование индивидуального тарифа на услугу',
          en: 'Редактирование индивидуального тарифа на услугу',
        },
      },
    ],
  },
  ADMIN_PANEL_TARIFF_ISSUANCE: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.TARIFF_ISSUANCE),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.TARIFF_ISSUANCE,
        description: {ru: 'Выдача тарифов', en: 'Выдача тарифов'},
      },
    ],
  },
  ADMIN_PANEL_TARIFF_ISSUANCE_STANDARD_TARIFF: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.TARIFF_ISSUANCE, URL_MAP.STANDARD_TARIFF),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.TARIFF_ISSUANCE,
        description: {ru: 'Выдача тарифов', en: 'Выдача тарифов'},
      },
      {
        route: URL_MAP.STANDARD_TARIFF,
        description: {ru: 'Выдача стандартного тарифа', en: 'Выдача стандартного тарифа'},
      },
    ],
  },
  ADMIN_PANEL_TARIFF_ISSUANCE_INDIVIDUAL_TARIFF: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.TARIFF_ISSUANCE, URL_MAP.INDIVIDUAL_TARIFF),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.TARIFF_ISSUANCE,
        description: {ru: 'Выдача тарифов', en: 'Выдача тарифов'},
      },
      {
        route: URL_MAP.INDIVIDUAL_TARIFF,
        description: {ru: 'Выдача индивидуального тарифа', en: 'Выдача индивидуального тарифа'},
      },
    ],
  },
  ADMIN_PANEL_TARIFF_ISSUANCE_STANDARD_TARIFF_SENT: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.TARIFF_ISSUANCE, URL_MAP.STANDARD_TARIFF, URL_MAP.SENT),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.TARIFF_ISSUANCE,
        description: {ru: 'Выдача тарифов', en: 'Выдача тарифов'},
      },
      {
        route: URL_MAP.SENT,
        description: {ru: 'Выдали стандартный тариф', en: 'Выдали'},
      },
    ],
  },
  ADMIN_PANEL_TARIFF_ISSUANCE_INDIVIDUAL_TARIFF_SENT: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.TARIFF_ISSUANCE, URL_MAP.INDIVIDUAL_TARIFF, URL_MAP.SENT),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.TARIFF_ISSUANCE,
        description: {ru: 'Выдача тарифов', en: 'Выдача тарифов'},
      },
      {
        route: URL_MAP.SENT,
        description: {ru: 'Выдали индивидуальный тариф', en: 'Выдали'},
      },
    ],
  },
  ADMIN_PANEL_VIDEO_MATERIALS: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.VIDEO_MATERIALS),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.VIDEO_MATERIALS,
        description: {ru: 'Видеоматериалы', en: 'Видеоматериалы'},
      },
    ],
  },
  ADMIN_PANEL_DOCUMENTS: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.DOCUMENTS),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.DOCUMENTS,
        description: {ru: 'Документы', en: 'Документы'},
      },
    ],
  },
  ADMIN_PANEL_DOCUMENTS_EDIT: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.DOCUMENTS, ':id'),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.DOCUMENTS,
        description: {ru: 'Документы', en: 'Документы'},
      },
      {route: ':id', description: ({ru = '', en = ''}) => ({ru, en}), param: 'id'},
    ],
  },
  ADMIN_PANEL_ABOUT_COMPANY: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.ABOUT_COMPANY),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.ABOUT_COMPANY,
        description: {ru: 'О компании', en: 'О компании'},
      },
    ],
  },
  ADMIN_PANEL_SOFTWARE_REQUIREMENTS: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.SOFTWARE_REQUIREMENTS),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.SOFTWARE_REQUIREMENTS,
        description: {ru: 'Требования к ПО', en: 'Требования к ПО'},
      },
    ],
  },
  ADMIN_PANEL_NEWS: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.NEWS),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.NEWS,
        description: {ru: 'Новости', en: 'Новости'},
      },
    ],
  },
  ADMIN_PANEL_NEWS_CREATE: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.NEWS, URL_MAP.CREATE),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.NEWS,
        description: {ru: 'Новости', en: 'Новости'},
      },
      {
        route: URL_MAP.CREATE,
        description: {ru: 'Добавить новость', en: 'Добавить новость'},
      },
    ],
  },
  ADMIN_PANEL_NEWS_EDIT: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.NEWS, ':id'),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.NEWS,
        description: {ru: 'Новости', en: 'Новости'},
      },
      {
        route: ':id',
        description: {ru: 'Редактирование новости', en: 'Редактирование новости'},
        param: 'id',
      },
    ],
  },
  ADMIN_PANEL_CONTACTS: {
    route: buildRoute(URL_MAP.ADMIN_PANEL, URL_MAP.CONTACTS),
    breadcrumbs: [
      {
        route: URL_MAP.ADMIN_PANEL,
        description: {ru: 'Административная панель', en: 'Административная панель'},
      },
      {
        route: URL_MAP.CONTACTS,
        description: {ru: 'Контакты', en: 'Контакты'},
      },
    ],
  },
  CONTROL_PANEL: {
    route: buildRoute(URL_MAP.CONTROL_PANEL),
    breadcrumbs: [
      {
        route: URL_MAP.CONTROL_PANEL,
        description: {ru: 'Панель контроля', en: 'Панель контроля'},
      },
    ],
  },
  CONTROL_PANEL_VIDEO: {
    route: buildRoute(URL_MAP.CONTROL_PANEL, ':videoType'),
    breadcrumbs: [
      {route: URL_MAP.CONTROL_PANEL, description: {ru: 'Панель контроля', en: 'Панель контроля'}},
      {route: ':videoType', description: ({ru = '', en = ''}) => ({ru, en}), param: 'videoType'},
    ],
  },
  FOUNDERS: {
    route: buildRoute(URL_MAP.FOUNDERS),
    breadcrumbs: [
      {
        route: URL_MAP.FOUNDERS,
        description: {
          ru: 'Видеоинтервью основателей - Мезенцева Д.П. и Калинова К.С.',
          en: 'Видеоинтервью основателей - Мезенцева Д.П. и Калинова К.С.',
        },
      },
    ],
  },
  FOUNDERS_DETAILS: {
    route: buildRoute(URL_MAP.FOUNDERS, ':id'),
    breadcrumbs: [
      {
        route: URL_MAP.FOUNDERS,
        description: {
          ru: 'Видеоинтервью основателей - Мезенцева Д.П. и Калинова К.С.',
          en: 'Видеоинтервью основателей - Мезенцева Д.П. и Калинова К.С.',
        },
      },
      {route: ':id', description: ({ru = '', en = ''}) => ({ru, en}), param: 'id'},
    ],
  },
  FEEDBACK: {
    route: buildRoute(URL_MAP.FEEDBACK),
    breadcrumbs: [
      {
        route: URL_MAP.FEEDBACK,
        description: {
          ru: 'Обратная связь',
          en: 'Обратная связь',
        },
      },
    ],
  },
  AUTH_FB: {route: buildRoute(URL_MAP.AUTH_FB)},
  AUTH_VK: {route: buildRoute(URL_MAP.AUTH_VK)},
  AUTH_OK: {route: buildRoute(URL_MAP.AUTH_OK)},
  AUTH_MAIL_RU: {route: buildRoute(URL_MAP.AUTH_MAIL_RU)},
  ACCOUNT_LINK_FB: {route: buildRoute(URL_MAP.ACCOUNT_LINK_FB)},
  ACCOUNT_LINK_VK: {route: buildRoute(URL_MAP.ACCOUNT_LINK_VK)},
  ACCOUNT_LINK_OK: {route: buildRoute(URL_MAP.ACCOUNT_LINK_OK)},
  ACCOUNT_LINK_MAIL_RU: {route: buildRoute(URL_MAP.ACCOUNT_LINK_MAIL_RU)},
  CARD_PAYMENT: {
    route: buildRoute(URL_MAP.CARD_PAYMENT),
    breadcrumbs: [
      {
        route: URL_MAP.CARD_PAYMENT,
        description: {ru: 'Оплата банковской картой', en: 'Оплата банковской картой'},
      },
    ],
  },
  REQUISITES_PAYMENT: {
    route: buildRoute(URL_MAP.REQUISITES_PAYMENT),
    breadcrumbs: [
      {
        route: URL_MAP.CARD_PAYMENT,
        description: {ru: 'Заявка на выставление счёта', en: 'Заявка на выставление счёта'},
      },
    ],
  },
  CART: {
    route: buildRoute(URL_MAP.CART),
    breadcrumbs: [
      {
        route: URL_MAP.CART,
        description: {ru: 'Ваша корзина', en: 'Ваша корзина'},
      },
    ],
  },
  RECORD_REQUEST: {
    route: buildRoute(URL_MAP.RECORD_REQUEST),
    breadcrumbs: [
      {
        route: URL_MAP.RECORD_REQUEST,
        description: {ru: 'Заявки на запись', en: 'Заявки на запись'},
      },
    ],
  },
  PROFILE_CONTACTS: {
    route: buildRoute(URL_MAP.PROFILE, URL_MAP.CONTACTS),
    breadcrumbs: [
      {
        route: buildRoute(URL_MAP.PROFILE, URL_MAP.CONTACTS),
        description: {ru: 'Контакты', en: 'Контакты'},
      },
    ],
  },
  PORTFOLIO: {
    route: buildRoute(URL_MAP.PORTFOLIO),
    breadcrumbs: [
      {
        route: URL_MAP.PORTFOLIO,
        description: {ru: 'Моё портфолио', en: 'Моё портфолио'},
      },
    ],
  },
  USER_PORTFOLIO: {
    route: buildRoute(URL_MAP.USERS, ':userId', URL_MAP.PORTFOLIO),
    breadcrumbs: [
      {
        route: URL_MAP.PORTFOLIO,
        description: {ru: 'Портфолио', en: 'Портфолио'},
      },
    ],
  },
  USER_PROFILE: {
    route: buildRoute(URL_MAP.USERS, ':userId'),
  },
  VIDEO_SESSIONS_ITEM: {
    route: buildRoute(URL_MAP.USERS, ':userId', URL_MAP.VIDEO_RECORD, ':id'),
  },
  HTML_LAYOUTS: {
    route: buildRoute(URL_MAP.HTML_LAYOUTS),
  },
  HTML_LAYOUTS_PAGE: {
    route: buildRoute(URL_MAP.HTML_LAYOUTS, ':page'),
  },
  ONLINE_POLL: {
    route: buildRoute(URL_MAP.ONLINE_POLL, ':key'),
  },

  VIDEO_SESSION: {
    route: buildRoute(URL_MAP.VIDEO_SESSION, ':id?'),
    breadcrumbs: [
      {
        route: URL_MAP.VIDEO_SESSION,
        description: {ru: 'Начать видеосессию', en: 'Start video session'},
      },
    ],
  },
  MY_VIDEO_SESSION: {
    route: buildRoute(URL_MAP.MY_VIDEO_SESSION),
    breadcrumbs: [
      {
        route: URL_MAP.MY_VIDEO_SESSION,
        description: {
          ru: 'Мои видеосессии',
          en: 'My video sessions',
        },
      },
    ],
  },
  VIDEO_VACANCY: {
    route: buildRoute(URL_MAP.VIDEO_VACANCY, ':id?'),
    breadcrumbs: [
      {
        route: URL_MAP.VIDEO_VACANCY,
        description: {ru: 'Запись видеовакансии', en: 'Video vacancies recording'},
      },
    ],
  },
  MY_VIDEO_VACANCY: {
    route: buildRoute(URL_MAP.MY_VIDEO_VACANCY),
    breadcrumbs: [
      {
        route: URL_MAP.MY_VIDEO_VACANCY,
        description: {
          ru: 'Мои видеовакансии',
          en: 'My video vacancies',
        },
      },
    ],
  },
  VIDEO_RESUME: {
    route: buildRoute(URL_MAP.VIDEO_RESUME, ':id?'),
    breadcrumbs: [
      {
        route: URL_MAP.VIDEO_RESUME,
        description: {ru: 'Запись видеорезюме', en: 'Video CV recording'},
      },
    ],
  },
  MY_VIDEO_RESUME: {
    route: buildRoute(URL_MAP.MY_VIDEO_RESUME),
    breadcrumbs: [
      {
        route: URL_MAP.MY_VIDEO_VACANCY,
        description: {
          ru: 'Мои видеорезюме',
          en: 'My video CVs',
        },
      },
    ],
  },
  VIDEO_BUSINESS_CARD: {
    route: buildRoute(URL_MAP.VIDEO_BUSINESS_CARD, ':id?'),
    breadcrumbs: [
      {
        route: URL_MAP.VIDEO_BUSINESS_CARD,
        description: {ru: 'Запись видеовизитки', en: 'Video business cards recording'},
      },
    ],
  },
  MY_VIDEO_BUSINESS_CARD: {
    route: buildRoute(URL_MAP.MY_VIDEO_BUSINESS_CARD),
    breadcrumbs: [
      {
        route: URL_MAP.MY_VIDEO_VACANCY,
        description: {
          ru: 'Мои видеовизитки',
          en: 'My video business card',
        },
      },
    ],
  },
};
